import React, { useState, useEffect, useContext } from 'react';
import { AdminAuthContext } from '../../AdminAuthContext';
import { useNavigate } from 'react-router-dom';

function AddUserForm() {
  const { admin, loading } = useContext(AdminAuthContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    repeatPassword: '',
    companyName: '',
    phoneNumber: '',
    shippingAddress: '',
    zipCode: '',
    country: '',
    billingAddress: '',
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [countries, setCountries] = useState([]);
  const [countryError, setCountryError] = useState(null);

  useEffect(() => {
    if (!loading && admin && admin.role === 'admin') {
      const fetchCountries = async () => {
        try {
          const response = await fetch('https://valleyapi-dr9y.onrender.com/api/countries', {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('admin_token')}`,
            },
          });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          setCountries(data);
        } catch (err) {
          setCountryError(`No se pudieron cargar los países: ${err.message}`);
        }
      };

      fetchCountries();
    }
  }, [loading, admin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!validateEmail(formData.email)) {
      newErrors.email = 'Invalid email address';
    }

    if (formData.password !== formData.repeatPassword) {
      newErrors.repeatPassword = 'Passwords do not match';
    }

    if (formData.password.length < 12) {
      newErrors.password = 'Password must be at least 12 characters';
    }

    if (!/^\d{4,10}$/.test(formData.zipCode)) {
      newErrors.zipCode = 'Zip Code must be 4 to 10 digits';
    }

    if (!/^\+?[0-9\s\-()]{7,20}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Invalid phone number format';
    }

    if (!formData.country) {
      newErrors.country = 'Please select a country';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const registerRes = await fetch('https://valleyapi-dr9y.onrender.com/api/admin/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('admin_token')}`,
      },
      body: JSON.stringify({
      email: formData.email,
      password: formData.password,
      name: formData.fullName,
      shipping_address: formData.shippingAddress,
      companyName: formData.companyName,
      companyNumber: formData.phoneNumber,
      billing_address: formData.billingAddress,
      country: formData.country,
      zipCode: formData.zipCode,
      }),
    });

      const registration = await registerRes.json();
      if (!registerRes.ok) {
        throw new Error(registration.error || 'Failed to register user');
      }
      setSubmitted(true);
    } catch (err) {
      alert(err.message);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!admin || admin.role !== 'admin') return <div>Acceso denegado</div>;
  if (countryError) {
    return <div style={{ textAlign: 'center', color: 'red' }}>{countryError}</div>;
  }
  if (submitted) {
    return (
      <div style={confirmationStyles}>
        <h2>User added successfully!</h2>
        <button
          style={submitButtonStyles}
          onClick={() => navigate('/admin/companies')}
        >
          Back to Companies
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={formStyles}>
      <h2 style={{ textAlign: 'center' }}>Add New User</h2>

      {[
        ['Full Name', 'fullName'],
        ['Email', 'email'],
        ['Password', 'password', 'password'],
        ['Repeat Password', 'repeatPassword', 'password'],
        ['Company Name', 'companyName'],
        ['Phone Number', 'phoneNumber', 'tel'],
        ['Shipping Address', 'shippingAddress'],
        ['Zip Code', 'zipCode'],
        ['Billing Address', 'billingAddress'],
      ].map(([label, name, type = 'text']) => (
        <div key={name} style={fieldStyles}>
          <label style={labelStyles}>{label}</label>
          <input
            type={type}
            name={name}
            value={formData[name]}
            onChange={handleChange}
            style={{ ...inputStyles, borderColor: errors[name] ? 'red' : '#ccc' }}
            required
          />
          {errors[name] && <p style={errorTextStyles}>{errors[name]}</p>}
        </div>
      ))}

      {/* Dropdown de paises */}
      <div style={fieldStyles}>
        <label style={labelStyles}>Country</label>
        <select
          name="country"
          value={formData.country}
          onChange={handleChange}
          style={{ ...inputStyles, borderColor: errors.country ? 'red' : '#ccc' }}
          required
        >
          <option value="">-- Select Country --</option>
          {countries.map((country) => (
            <option key={country.idPais} value={country.Country}>
              {country.Country}
            </option>
          ))}
        </select>
        {errors.country && <p style={errorTextStyles}>{errors.country}</p>}
      </div>

      <button type="submit" style={submitButtonStyles}>Add User</button>
    </form>
  );
}

// Styles
const formStyles = {
  maxWidth: '500px',
  margin: '0 auto',
  padding: '2rem',
  borderRadius: '8px',
  backgroundColor: '#f9f9f9',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
};

const fieldStyles = {
  marginBottom: '15px',
};

const labelStyles = {
  display: 'block',
  marginBottom: '5px',
  fontWeight: 'bold',
};

const inputStyles = {
  width: '100%',
  padding: '10px',
  fontSize: '14px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  boxSizing: 'border-box',
};

const errorTextStyles = {
  color: 'red',
  fontSize: '12px',
  marginTop: '5px',
};

const submitButtonStyles = {
  backgroundColor: '#28a745',
  color: 'white',
  padding: '10px',
  width: '100%',
  fontSize: '16px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const confirmationStyles = { 
  textAlign: 'center', 
  padding: '50px', 
  fontSize: '18px' 
};

export default AddUserForm;
